import axios from 'axios';
import analytics from 'shared/utility/analytics';

export const getToolSettings = async setBroken => {
  const response = await axios.get('/rente-top-5/tool-settings').catch(() => setBroken(true));
  const { uaCode } = response.data;
  analytics.init('G-24T2SRE2N6', uaCode);
  return response?.data;
};

export const getInterestRates = async (frt, nhg, ltv, setBroken, setData) => {
  const response = await axios({
    url: '/rente-top-5/calculate/top-five-interest-rates',
    method: 'post',
    data: { frt, nhg, ltv },
  }).catch(() => setBroken(true));

  setData(response.data);
};

export const getFrtOptions = settings => {
  const selectedFrts = [
    settings.renteWidgetsFrt1,
    settings.renteWidgetsFrt2,
    settings.renteWidgetsFrt3,
    settings.renteWidgetsFrt4,
    settings.renteWidgetsFrt5,
  ];

  return selectedFrts.map(frt => ({
    label: frt === 0 ? 'Variabel' : `${frt} jaar`,
    value: frt,
  }));
};
